import { Component } from 'react';

// Global safety net: if any page throws during render, show a friendly recovery
// screen instead of a blank white page. Prevents a single JS error from taking
// down the whole admin or checkout.
export default class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, info) {
    // eslint-disable-next-line no-console
    console.error('UI crash caught by ErrorBoundary:', error, info);
  }

  handleReload = () => {
    this.setState({ hasError: false });
    window.location.reload();
  };

  render() {
    if (this.state.hasError) {
      return (
        <div className="min-h-screen flex items-center justify-center bg-white p-6">
          <div className="max-w-md w-full text-center border border-zinc-200 rounded-lg p-10" data-testid="app-error-boundary">
            <div className="w-14 h-14 mx-auto rounded-full bg-amber-50 border border-amber-200 flex items-center justify-center mb-5 text-2xl">⚠️</div>
            <h1 className="font-display text-xl font-bold tracking-tight mb-2">Un instant…</h1>
            <p className="text-sm text-zinc-600 mb-6">
              Une erreur d'affichage est survenue. Rechargez la page pour continuer — vos données sont en sécurité.
            </p>
            <button
              type="button"
              onClick={this.handleReload}
              data-testid="error-boundary-reload"
              className="h-11 px-6 rounded-md bg-zinc-900 text-white text-sm font-semibold hover:opacity-90 transition"
            >
              Recharger la page
            </button>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}
